import { useReduxBlog } from './useReduxBlog';
import React from 'react';
import { Grid, TWO_COLUMN_MAX_WIDTH } from '@spotify-internal/frodor-modules';
import styled from 'styled-components';
import {
  cssColorValue,
  screenMdMin,
  screenSmMin,
  screenXsMax,
  Text,
  spacer24,
} from '@spotify-internal/encore-web';
import { HeaderImageGrid } from '../ui/HeaderImageGrid';
import { useT, useNumberFormatter } from '../../../features/src/i18n';
import { ButtonTertiary } from '@spotify-internal/encore-web-v6';

const Title = styled(Text)`
  z-index: 2;
  grid-row: 2;
  display: flex;
  align-items: flex-end;
`;

const HeroContent = styled.div`
  @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
    display: none;
  }
  grid-row: 3;
  grid-column: 5/12;
  z-index: 2;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  flex-direction: column;

  //spbootstrap override
  a {
    text-decoration: none !important;
    :hover {
      color: ${cssColorValue('textBase')} !important;
    }
  }
`;

export const ArtistBanner = () => {
  const { hero } = useReduxBlog();
  const t = useT();
  const numberFormatter = useNumberFormatter();

  return (
    <div className="encore-inverted-dark-set">
      <HeaderImageGrid backgroundImage={hero && `url("${hero.bannerImage}")`}>
        <Title variant="headlineLarge">
          {' '}
          {t('FRODOR_278509', 'News', '')}{' '}
        </Title>
        {hero && (
          <HeroContent>
            <Text
              as={ButtonTertiary}
              style={{ fontSize: '24px', padding: '0px' }}
              target="_blank"
              rel="noopener noreferrer"
              href={`https://open.spotify.com/artist/${hero.artistId}?utm_campaign=s4a|header|${hero.artistId}&utm_source=s4a&utm_medium=s4aheader`}
              aria-label={t(
                'FRODOR_893097',
                'listen to {artistName} on Spotify',
                '',
                {
                  artistName: hero.artistName,
                },
              )}
              variant="titleLarge"
            >
              {hero.artistName}
            </Text>
            {hero.listeners && (
              <Text variant="bodyMediumBold">
                {t(
                  'FRODOR_e69386',
                  '{monthlyListeners} Monthly Listeners',
                  '',
                  {
                    monthlyListeners: (numberFormatter as $TSFixMe).format(
                      hero.listeners,
                    ),
                  },
                )}
              </Text>
            )}
          </HeroContent>
        )}
      </HeaderImageGrid>
    </div>
  );
};
